export default __webpack_public_path__ + "static/pedals-illustration-d6066422a1fc227d29c0f4883b8206b9.png";